import axios from "axios";

export default {
    namespaced: true,

    state: {

    },

    mutations: {

    },

    actions: {
        find({ }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/finances/cash-flows/${id}`)
                    .then((res) => {
                        resolve(res.data.data.cash_flow);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        create({ }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/finances/cash-flows", data)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        update({ }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/finances/cash-flows/${data.get("id")}`, data)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        delete({ }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/finances/cash-flows/${id}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        restore({ }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/finances/cash-flows/${id}/restore`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        updateForecastData({ }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/finances/cash-flows/forecasts", data)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getForecastData({ }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/finances/cash-flows/forecasts/${id}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getActualsData({ }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/finances/cash-flows/actuals/${id}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getForecastSummaryData({ }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/finances/cash-flows/summary/forecasts/${id}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getActualsSummaryData({ }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/finances/cash-flows/summary/actuals/${id}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },

    getters: {},
};
